<div class="organisation-container">
  <app-menu [screen]="screen"></app-menu>
  @if (loading) {
    <spinner-overlay [overlay]=true></spinner-overlay>
  }
  <mat-card appearance="raised">
    <mat-card-header>
      <mat-card-title><h3>Billing runs</h3></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (billingRuns && billingRuns.length > 0) {
        <app-bar-chart [data]="chartData" indexAxis="x" [isStacked]="true" [width]="875" [height]="600" [sort]="false" [stacks]="['Nodes', 'Projects', 'Users']" (selectNodeEvent)="handleBarSelection($event)"></app-bar-chart>
        <app-billing-run-table [billingRuns]="billingRuns" [selectedRunId]="selectedRunId" (selectRunEvent)="handleBarSelectionNumber($event)"></app-billing-run-table>
        }@else {
        <p>There are no billing runs. Press create billing run to create first one.</p>
      }
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="accent" (click)="createBillingRun()">Create billing run</button>
      <button mat-raised-button color="accent" (click)="executeBillingRun()" [disabled]="!selectedRunId">Execute billing run payments</button>
      <button mat-raised-button color="accent" (click)="checkBillingRun()" [disabled]="!selectedRunId">Check billing run state</button>
      <button mat-raised-button color="accent" (click)="exportRuns()">Export runs</button>
    </mat-card-actions>
  </mat-card>
  @if (selectedRunId && billingRecords) {
    <mat-card appearance="raised">
      <mat-card-header>
        <h3 style="margin-right: 30px;">Selected run details</h3>
        <button mat-raised-button color="accent" (click)="exportRun()" [disabled]="!selectedRunId">Export run</button>
      </mat-card-header>
      <mat-card-content>
        <app-billing-records-table [billingRecords]="billingRecords"></app-billing-records-table>
      </mat-card-content>
    </mat-card>
  }
</div>
